import React from 'react';

const Blogs = () => {
    return (
        <div>
            <h3 className="text-center mt-5 text-uppercase" 
            style={{color:'#73DFC9'}}>Blog is comming soon</h3>
        </div>
    );
};

export default Blogs;